window.addEventListener("click", function (evt) {
  if (evt.target.classList.contains("drawer-upsell-card-info-atc")) {
    evt.preventDefault();
    evt.stopPropagation();
    fetch(window.routes.cartAddUrl + ".js", {
      body: JSON.stringify({
        id: evt.target.dataset.variantId,
        quantity: 1,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );
        const $topListItems = document.querySelector(
          "#sidebar-cart .Drawer__Main"
        );
        $topListItems.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    });
  }
});
